export default __webpack_public_path__ + "static/media/graphic_no_bid_placed.0e7af1bc.svg";